import { FormLabel as FL } from '@chakra-ui/react';

export const FormLabel = ({
    fieldName,
    labelWidth,
    label,
}: {
    fieldName: string;
    label: string;
    labelWidth?: string;
}) => (
    <FL htmlFor={fieldName} m={0} p={0} mr={labelWidth ? 0 : 2} lineHeight="shorter" width={labelWidth} flexShrink={0}>
        {label}
    </FL>
);
